import React, { Component } from 'react';
import { connect } from 'react-redux';
import LoadingControl from '../../../components/LoadingControl';
import CalibrationV3AgentScreen from './agents/CalibrationV3AgentScreen';
import CalibrationV3ManagerScreen from './manager/CalibrationV3ManagerScreen';
import CalibrationV3SupervisorScreen from './supervisor/CalibrationV3SupervisorScreen';

import { pageLoaded } from '../../../utils';
import { ZRole } from '../../../generated';

class CalibrationV3Screen extends Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        pageLoaded('Jibe');
    }

    render() {
        const
            {
                currentUser,
            } = this.props;
        if (!currentUser) {
            return <LoadingControl />;
        }

        if (currentUser.RoleId == ZRole.Agent) {
            return <CalibrationV3AgentScreen />
        }
        else if (currentUser.RoleId == ZRole.Supervisor) {
            return <CalibrationV3SupervisorScreen />;
        }
        else if (currentUser.RoleId == ZRole.Manager ||
            currentUser.RoleId == ZRole.Admin ||
            currentUser.RoleId == ZRole.SuperAdmin) {
            return <CalibrationV3ManagerScreen />
        }
    }
}

const select = state => ({ ...state.session });

export default connect(select)(CalibrationV3Screen);